import { capitalize } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GalleryCard } from '../../../../components/gallery/LibraryGalleryCard';
import { GalleryViewMode } from '../../../../components/gallery/types';
import { Scheme } from '../types';

interface SchemeCardProps {
  item: Scheme;
  viewMode: GalleryViewMode;
  focusOptions: { name: string; id: string }[];
  sx?: any;
  onClick: (item: Scheme) => void;
}

export const SchemeCard = ({
  item,
  viewMode,
  focusOptions,
  sx,
  onClick,
}: SchemeCardProps) => {
  const { t } = useTranslation();
  const { name, focuses, sets } = item;

  const weeks = Math.max(...sets.map((s) => s.cycleIndex)) + 1;
  const focusNames = focuses.map((f) => {
    const focus = focusOptions.find((fo) => fo.id === f.focusId);
    return focus ? focus.name : '';
  });

  return (
    <GalleryCard
      title={name}
      imgUrl={undefined}
      viewMode={viewMode}
      onClick={() => onClick(item)}
      sx={sx}
    >
      <p>
        {t('weekCount', { count: weeks })}
        <br />
        {focusNames.map(capitalize).join(', ')}
      </p>
    </GalleryCard>
  );
};
